// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidVentilation from '../_raw/service/icon_covid_ventilation.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidVentilation);
